<div class="progress-bar">
  <div class="indeterminate"></div>
</div>
